import { useEffect, useRef } from "react";
import type React from "react";

/**
 * Returns a ref to attach to a container; `onAway` fires on a pointerdown
 * outside it (used to close menus/dropdowns). Shared by the TopBar menus and
 * the feed's keyword-filter dropdown.
 */
export function useClickAway(onAway: () => void): React.RefObject<HTMLDivElement | null> {
  const ref = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    function handler(e: PointerEvent): void {
      if (ref.current && !ref.current.contains(e.target as Node)) onAway();
    }
    document.addEventListener("pointerdown", handler);
    return () => document.removeEventListener("pointerdown", handler);
  }, [onAway]);
  return ref;
}
